import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { SnmpDestination } from 'data/snmp/snmp.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  snmpDestServerData: SnmpDestination,
  originalSnmpDestServerDataServerFormData: SnmpDestination | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.SNMP_DEST_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.SNMP_DEST_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(snmpDestServerData, null, isEdit, originalSnmpDestServerDataServerFormData),
    snmpDestServerData.NAME,
    AuditService.SNMP_DEST,
    actionType,
  );
  return auditDetails as AuditDetails;
}
